import CTLBooleanCell from "application/components/CTLBooleanCell";
import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import { adminMenus } from "globals/configuration/admin";

const Attributes = {
  formSize: "sm",
  enableAddButton: false,
  settingsMode: false,
  enableAdvanceSearch: true,
  enableMultipleUpdate: true,
  modes: adminMenus.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
      disabled: item.disabled,
      productionReady: item.productionReady,
    };
  }),
};

const operationURLS = {
  update: "/menu/updateMenu",
  list: "/menu/list",
};
const getColumns = (onDelete, onEdit) => {
  return [
    {
      Header: "Menu Name",
      accessor: "menuName",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      disabled:true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Menu Group Name",
      accessor: "menuGroupName",
      displayInList: true,
      allowInForm: false,
      allowFilter: true,
      dataType: "string",
      width: 12,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "IsActive",
      accessor: "isActive",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      width: 6,
      controlType: "boolean",
      Cell: ({ value }) => <CTLBooleanCell value={value} />,
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => (
        <RowAction row={row} value={value} onEdit={onEdit} />
      ),
    },
  ];
};

export { getColumns, Attributes, operationURLS };
